import cn from 'clsx'

import React from 'react'
import { useDispatch, useSelector } from 'hooks/use-redux'
import ShortlistToggle from 'assets/icons/shortlist-toggle-v2.svg'
import { toggleShortlists } from '@disco/state-management/actions/AppActions'
import styles from './index.module.css'

const MobileShortlistsSwitch = (): React.ReactElement<'button'> => {
  const dispatch = useDispatch()
  const shortlistsOpen = useSelector(state => state.app.shortlistsOpen)
  return (
    <button
      className={cn('phone-only', styles.explorerShortlistsToggleBtn, {
        [styles.explorerShortlistsToggleBtnDisabled]: shortlistsOpen,
      })}
      onClick={() => {
        dispatch(toggleShortlists())
      }}
      aria-label="Toggle shortlist"
    >
      <ShortlistToggle />
    </button>
  )
}

export default MobileShortlistsSwitch
